//#region New Code
// import React from 'react';
// import SortTable from '../SortTable';
// import ListResults from '../ListResults';
// import shallowequal from 'shallowequal';
// import Icon from '../Icon';
// import { Link } from 'react-router';
// import svgEdit from '../../svgs/edit.svg';
// import { executeQuery } from "../../requests/executeQuery";
// import { LENDERS_LIST, LENDERS_LIST_COUNT } from '../../consts/queries';
// import LinkComp from "../LinkComp";
// import plus from "../../svgs/plus-white.svg";
// import filter from "../../filter";
// import { ApolloConsumer } from '@apollo/client';
// import { GET_LENDERS } from '../Graphql/Queries/LendersQuery';

// const limit = 50;

// export default class LenderList extends React.Component {
//     constructor(props) {
//         super(props);

//         this.state = {
//             items: null,
//             totalCount: null,
//             error: null,
//             isBusy: null,
//         };
//     }

//     componentDidMount() {
//         if (this.client) {
//             this.fetch(this.props.location.query);
//         }
//     }

//     fetch(q) {
//         this.setState({ isBusy: true });
//         const query = { ...q };
//         const options = filter(query, 'lenders');
//         options.param.limit = limit;
//         options.param.offset = query.page ? ((Number(query.page) - 1) * limit) : 0;

//         var pageParams = {
//             page: query.page ? Number(query.page) : 1,
//             pageSize: limit
//         }

//         // Promise.all([
//         //     executeQuery({ queryName: LENDERS_LIST, options: options }),
//         //     executeQuery({ queryName: LENDERS_LIST_COUNT, options: options })
//         // ]).then(res => {
//         //     this.setState({
//         //         items: res[0].data,
//         //         totalCount: res[1].success && res[1].data[0] ? Number(res[1].data[0].TOTAL_COUNT) : false,
//         //         error: res[0].success ? null : res[0].message,
//         //         isBusy: null,
//         //     });
//         // });

//         if (this.client) {
//             const token = localStorage.getItem('authToken');
//             this.client.query({
//                 query: GET_LENDERS, variables: { pageOptions: pageParams }, fetchPolicy: "no-cache",
//                 context: {
//                     headers: {
//                         authorization: `Bearer ${token}`, // Bearer token added here
//                     },
//                 }
//             }).then(res => {
//                     
//                     this.setState({
//                         items: res.data.getLenders,
//                         totalCount: res.data.getLenders.length,
//                         error: null,
//                         isBusy: null,
//                     });
//                 })
//                 .catch(err => {
//                     this.setState({
//                         error: err.message,
//                         isBusy: null,
//                     });
//                 });
//         }
//     }

//     componentDidUpdate(prevProps) {
//         if (!shallowequal(prevProps.location.query, this.props.location.query)) {
//             this.fetch(this.props.location.query);
//         }
//     }

//     render() {
//         const query = this.props.location.query;

//         const columns = [
//             {
//                 name: 'View',
//                 textAlign: 'center',
//                 columnStyle: { width: 70 },
//                 render: (el) => (
//                     <Link to={{ pathname: `${arc.path.base}lender/${el.arcimedes_row_id}` }}><Icon svg={svgEdit} /></Link>
//                 ),
//             },
//             {
//                 code: 'NAME',
//                 name: 'Lender Name',
//                 render: (el) => el.name,
//             },
//             {
//                 code: 'CITY',
//                 name: 'City',
//                 render: (el) => el.city,
//             },
//             {
//                 code: 'STATE',
//                 name: 'State',
//                 render: (el) => el.state,
//             },
//             {
//                 code: 'CONTACT_NAME',
//                 name: 'Contact Name',
//                 render: (el) => el.contact_name,
//             },
//             {
//                 code: 'CONTACT_PHONE',
//                 name: 'Phone #',
//                 render: (el) => el.contact_phone,
//             },
//             {
//                 code: 'CONTACT_EMAIL',
//                 name: 'Email',
//                 render: (el) => el.contact_email,
//             },
//         ];

//         return (
//             <ApolloConsumer>
//                 {client => {
//                     if (!this.client) {
//                         this.client = client;
//                         this.fetch(this.props.location.query);
//                     }
//                     return (
//                         <div className='LenderList' data-is-busy={this.state.isBusy}>
//                             <div className='page-rounded-corner-container'>
//                                 <div className='page-header-container list'>
//                                     <div className='page-header list'>
//                                         <div className='page-title'>Lenders</div>
//                                         <LinkComp to={`${arc.path.base}lender`}>
//                                             <div className="button-new plus positive">
//                                                 <Icon svg={plus} />
//                                             </div>
//                                         </LinkComp>
//                                     </div>
//                                     <div className='line' />
//                                 </div>
//                             </div>
//                             <div className='page-body-container'>
//                                 <SortTable columns={columns}
//                                     items={this.state.items}
//                                     query={query}
//                                 />
//                                 <ListResults query={this.props.location.query}
//                                     pathname={this.props.location.pathname}
//                                     error={this.state.error}
//                                     totalCount={this.state.totalCount}
//                                     itemCount={this.state.items ? this.state.items.length : false}
//                                     limit={limit}
//                                 />
//                             </div>
//                         </div>
//                     )
//                 }}
//             </ApolloConsumer>

//         );
//     }
// }
//#endregion

import React from 'react';
import SortTable from '../SortTable';
import ListResults from '../ListResults';
import shallowequal from 'shallowequal';
import Icon from '../Icon';
import { Link } from 'react-router';
import svgEdit from '../../svgs/edit.svg';
import { executeQuery } from "../../requests/executeQuery";
import { LENDERS_LIST, LENDERS_LIST_COUNT } from '../../consts/queries';
import LinkComp from "../LinkComp";
import plus from "../../svgs/plus-white.svg";
import filter from "../../filter";
import { ApolloConsumer } from '@apollo/client';
import { GET_LENDERS } from '../Graphql/Queries/LendersQuery';
import { GET_CONTACT_LENDERS_LIST_QUERY } from '../Graphql/ContactsQueries/contactsQuery';
import { fetchData } from '../Service/graphQlService';
const limit = 50;

export default class LenderList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            items: null,
            totalCount: null,
            error: null,
            isBusy: null,
        };
    }

    componentDidMount() {
        this.fetch(this.props.location.query);
    }

    parseSortOptions(orderQuery) {
        if (orderQuery && Array.isArray(orderQuery)) {
            return orderQuery.map((item, index) => {
                const [field, order] = item.split('.');
                return {
                    field: field,
                    order: order
                };
            });
        }
        else if (orderQuery) {
            const [field, order] = orderQuery.split('.');
            return [{
                field: field,
                order: order
            }];
        }
        else{
            return [];
        }

    }

    parseFilterOptions(query){
        const filterObject = {};
        if(query){
            for(const key in query){
                if(key !== 'order' && key !== 'page'){
                    filterObject[key]= query[key]
                }
            }
        }
        return [filterObject]
    }


    fetch(q) {
        this.setState({ isBusy: true });
        const query = { ...q };
        const options = filter(query, 'lenders');
        options.param.limit = limit;
        options.param.offset = query.page ? ((Number(query.page) - 1) * limit) : 0;
        // Promise.all([
        //     executeQuery({ queryName: LENDERS_LIST, options: options }),
        //     executeQuery({ queryName: LENDERS_LIST_COUNT, options: options })
        // ]).then(res => {
        //         this.setState({
        //             items: res[0].data,
        //             totalCount: res[1].success && res[1].data[0] ? Number(res[1].data[0].TOTAL_COUNT) : false,
        //             error: res[0].success ? null : res[0].message,
        //             isBusy: null,
        //         });
        //     });
        var pageParams = {
            page: query.page ? Number(query.page) : 1,
            pageSize: limit
        }
        const sortOptions = this.parseSortOptions(q.order);
        const filterOptions = this.parseFilterOptions(q); 
        if (this.client) {
            const token = localStorage.getItem('authToken');
            // this.client.query({
            //     query: GET_CONTACT_LENDERS_LIST_QUERY, variables: {type: "Lender", pageOptions: pageParams, filters: filterOptions, sortOptions: sortOptions }, fetchPolicy: "no-cache",
            //     context: {
            //         headers: {
            //             authorization: `Bearer ${token}`, // Bearer token added here
            //         },
            //     }
            // })
            fetchData(GET_CONTACT_LENDERS_LIST_QUERY, {type: "Lender", pageOptions: pageParams, filters: filterOptions, sortOptions: sortOptions })
            .then(res => {
                        this.setState({
                            items: res.data.getContacts.data,
                            totalCount: res.data.getContacts.totalCount,
                            // error: res[0].success ? null : res[0].message,
                            error:null,
                            isBusy: null,
                        });
                    })
                .catch(err => {
                    this.setState({
                        error: err.message,
                        isBusy: null,
                    });
                });
        }
    }

    componentDidUpdate(prevProps) {
        if (!shallowequal(prevProps.location.query, this.props.location.query)) {
            this.fetch(this.props.location.query);
        }
    }

    render() {
        const query = this.props.location.query;

        const columns = [
            {
                name: 'View',
                textAlign: 'center',
                columnStyle: { width: 70 },
                // render: (el) => (
                //     <Link to={{ pathname: `${arc.path.base}lender/${el.contact_id}` }}><Icon svg={svgEdit} /></Link>
                // ),
                render: (el) => {
					const basePath = arc.path.base.endsWith('/') ? arc.path.base.slice(0, -1) : arc.path.base;
					const currentSearch = window.location.search;
					const currentPath = window.location.pathname + currentSearch;
				  
					return (
					  <Link to={{
						pathname: `${basePath}/lender/${el.contact_id}`,
						state: { fromListUrl: currentPath }
					  }}>
						<Icon svg={svgEdit} />
					  </Link>
					);
				  }
            },
            {
                code: 'name',
                name: 'Company',
                render: (el) => el.name,
            },
            {
                code: 'city',
                name: 'City',
                render: (el) => el.city,
            },
            {
                code: 'state',
                name: 'State',
                render: (el) => el.state,
            },
            {
                code: 'first_name',
                name: 'Contact First Name',
                render: (el) => el.first_name,
            },
            {
                code: 'last_name',
                name: 'Contact Last Name',
                render: (el) => el.last_name,
            },
            {
                code: 'contact_phone',
                name: 'Phone #',
                render: (el) => el.contact_phone,
            },
            // {
            //     code: 'contact_email',
            //     name: 'Email',
            //     render: (el) => el.contact_email,
            // }
            {
                code: 'email',
                name: 'Email',
                render: (el) => el.email,
            }
            ,{
				code: 'address',
				name: 'Address',
				render: (el) => el.address,
			},{
				code: 'zip',
				name: 'ZIP',
				render: (el) => el.zip,
			}
        ];

        return (
            <ApolloConsumer>
                {client => {
                    if (!this.client) {
                        this.client = client;
                    }
                    return (
                        <div className='LenderList' data-is-busy={this.state.isBusy}>
                            <div className='page-rounded-corner-container'>
                                <div className='page-header-container list'>
                                    <div className='page-header list'>
                                        <div className='page-title'>Lenders</div>
                                        <LinkComp
                                            to={{
                                                pathname: `${arc.path.base}lender`,
                                                state: { fromListUrl: window.location.pathname + window.location.search }
                                            }}
                                        >
                                            <div className="button-new plus positive">
                                                <Icon svg={plus} />
                                            </div>
                                        </LinkComp>
                                    </div>
                                    <div className='line' />
                                </div>
                            </div>
                            <div className='page-body-container'>
                                <SortTable columns={columns}
                                    items={this.state.items}
                                    query={query}
                                />
                                <ListResults query={this.props.location.query}
                                    pathname={this.props.location.pathname}
                                    error={this.state.error}
                                    totalCount={this.state.totalCount}
                                    itemCount={this.state.items ? this.state.items.length : false}
                                    limit={limit}
                                />
                            </div>
                        </div>
                    )
                }}
            </ApolloConsumer>

        );
    }
}
